// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"jr","firstSessionModal_header":"kr","firstSessionModal_title":"lr","firstSessionModal_header_tex":"mr","firstSessionModal_video":"nr","firstSessionModal_videoContent":"or","firstSessionModal_FAQ":"pr","firstSessionModal_FAQMargin":"qr","firstSessionModal_FAQTitle":"rr","firstSessionModal_buttonContainer":"sr","firstSessionModal_buttonText":"tr","firstSessionModal_SMSBtn_mob":"ur"};
    if(module.hot) {
      // 1713361643377
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  